import { ACCOUNT_ROUTE_NAME } from "@/libs/route-name";

export const accountRoute = () => {
  return {
    name: ACCOUNT_ROUTE_NAME.ACCOUNT,
    path: "/account",
    component: () => import("@/pages/account/index.vue")
  };
};
